<button class="custom-btn {{ disabled ? 'disabled-btn' : '' }}" mat-button [ngStyle]="getStyles()" [disabled]="disabled" (click)="onClick($event)">
  <span *ngIf="!loading; else loader" [@elemShow]>
    {{ text }}
  </span>
  <ng-template #loader>
    <dn-loader [loaderSize]="loaderSize" />
  </ng-template>
</button>
